import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import sidemenucss from "../../css/sidemenu.module.css";
import commoncss from "../../css/common.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { ReactComponent as BaseCorp } from "../../assets/icons/base-corp.svg";

import { ReactComponent as Plus } from "../../../myfin_v2/assets/icons/plusBlack.svg";

const ConsoleSideMenu = ({ menuItems, title, activeItem, setActiveTab,bsNotesSubmenu,setBSNotesVal, adjustmentMenuItems }) => {
  const dispatch = useDispatch();

  const routerHistory = useHistory();

  const [activeItemInPNLSubMenu, setactiveItemInPNLSubMenu] = useState(0);
  const [activeItemInGNSubMenu, setActiveItemInGNSubMenu] = useState(0);
  const [activeItemInAdjustmentsSubMenu, setActiveItemAdjustmentsSubMenu] = useState(0);

  const [activeItemInBSSubMenu, setActiveItemInBSSubMenu] = useState(0);
  const [activeDiscSubMenu, setActiveDiscSubMenu] = useState(0);
  const [
    activeItemDisclosureCheckSubMenu,
    setactiveItemDisclosureCheckSubMenu,
  ] = useState(0);

  console.log("activeItem",activeItem);

  const handleClick = (Link) => {
    if (Link) {
      routerHistory.push(Link);
    }
  };

  console.log("bsNotesSubmenu",bsNotesSubmenu);
  

  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    >
      <div
        className={sidemenucss.sidemenuHeader}
        style={{ "min-height": "15vh" }}
      >
        <span className={sidemenucss.sidemenuTitle}>{title}</span>
        {/* <span className={sidemenucss.sidemenuSubTitle}>workspace name</span> */}
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop} ${commoncss.hideScroll} pt-0`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                onClick={() => {
                  setActiveTab(index);
                }}
                className={`${sidemenucss.sidemenuItem} ${
                  activeItem === index ? sidemenucss.sidemenuItemActive : ""
                }`}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                  </div>
                </span>
              </li>
              {activeItem === 4 && index === 4 && bsNotesSubmenu && (
                <>
                  <div className={sidemenucss.submenuContainer}>
                    {bsNotesSubmenu.map((noteGroup, idx) => (
                      <div
                        key={idx}
                        // className={`${sidemenucss.submenuItem} ${
                        //   activeItemInPNLSubMenu === note.name
                        //     ? sidemenucss.activeSubMenu
                        //     : null
                        // }`}
                        className={`${sidemenucss.submenuItem} ${
                          activeItemInGNSubMenu === idx
                            ? sidemenucss.activeSubMenu
                            : ""
                        }`}
                        onClick={() => {
                          // setBSActiveTab(idx);
                          // handleTabs(idx);
                          // setActiveItemInBSSubMenu(idx);
                          
                // value={Number(getIndexNumber(noteGroup))}
                setBSNotesVal()
                        }}
                      >
                        {noteGroup.label}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {activeItem === 6 && index === 6 && adjustmentMenuItems && (
                <>
                  <div className={sidemenucss.submenuContainer}>
                    {adjustmentMenuItems.map((noteGroup, idx) => (
                      <div
                        key={idx}
                        // className={`${sidemenucss.submenuItem} ${
                        //   activeItemInPNLSubMenu === note.name
                        //     ? sidemenucss.activeSubMenu
                        //     : null
                        // }`}
                        className={`${sidemenucss.submenuItem} ${
                          activeItemInAdjustmentsSubMenu === idx
                            ? sidemenucss.activeSubMenu
                            : ""
                        }`}
                        onClick={() => {
                          // setBSActiveTab(idx);
                          // handleTabs(idx);
                          // setActiveItemInBSSubMenu(idx);
                          
                // value={Number(getIndexNumber(noteGroup))}
                // setBSNotesVal()
                        }}
                      >
                        {noteGroup.label}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ConsoleSideMenu;
